import { DropdownItem } from '@/main/store/@types/dropdown.d';
import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { updateEditAction } from '@/main/store/actionsFunctions';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';
import { editActions } from './types';

const edit = {
	ID: null as number | null,
	CustomerName: null as string | null,
	CustomerEmail: null as string | null,
	CustomerPhone: null as string | null,
	Quantity: null as number | null,
	AvailabilityDateTime: null as string | null,
	PartNumber: null as string | null,
	isvisible: true,
};

export type ProvozovnaIdDropDownList = DropdownItem & { selected: boolean };

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	depTableNames: [],
	depTableSettings: {},
	edit,
	localState: {},
	extraActions: {
		[editActions.SEND_REMINDERS]: ({ state, commit, dispatch }, { ID }) => updateEditAction(
			state, commit, dispatch,
			apiProvider.sendReminders(ID),
		),
	},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
	},
});
